import { zSchema } from "../schema-validation";

export const getSSEBaseSchema = <T extends zSchema.ZodTypeAny>(dataSchema: T) =>
  zSchema.object({
    event: zSchema.string(),
    data: dataSchema,
  });
